import { render, staticRenderFns } from "./StructureRow.vue?vue&type=template&id=620ec701&scoped=true&"
import script from "./StructureRow.vue?vue&type=script&lang=js&"
export * from "./StructureRow.vue?vue&type=script&lang=js&"
import style0 from "./StructureRow.vue?vue&type=style&index=0&id=620ec701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ec701",
  null
  
)

export default component.exports